import { useEffect } from 'react';
import { deferUntilNewTitle } from '@moda/portal-stanchions';
import { useCart } from '../useCart';
import { tc } from '../../lib/trackingContext';
import { useUser } from '../useUser';

export const useCheckoutStartTracking = () => {
  const { cart, loaded: cartLoaded } = useCart();
  const { user } = useUser();

  useEffect(() => {
    if (cartLoaded && user.accessToken) {
      deferUntilNewTitle(() => {
        tc.track('Checkout Started', {
          addToScopeOnce: {
            cart,
            user,
            products: cart.attributes.cartItems.map(item => item.data)
          }
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartLoaded, user?.accessToken]);
};
